import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../shared/components/Icon';
import { applyUpdate, subscribeToUpdates } from './serviceWorker';

/**
 * A new release is ready, and the operator decides when it arrives.
 *
 * An installed application stays open for days, so it has to be told about a deployment. It must
 * not act on that by itself: reloading the window while someone is entering a journal would throw
 * away work the server has never seen.
 */
export function UpdateBanner() {
  const { t } = useTranslation();
  const [ready, setReady] = useState(false);
  const [applying, setApplying] = useState(false);

  useEffect(() => subscribeToUpdates(setReady), []);

  if (!ready) return null;

  return (
    <div className="update-banner" role="status" aria-live="polite">
      <Icon name="download" />
      <span>{t('pwa.update.available')}</span>
      <button
        className="button button--primary button--small"
        type="button"
        disabled={applying}
        onClick={() => {
          setApplying(true);
          applyUpdate();
        }}
      >
        {applying ? t('pwa.update.applying') : t('pwa.update.reload')}
      </button>
    </div>
  );
}
